export * from './ProductsListItemLightboxTitle.types';
export { default as ProductsListItemLightboxTitle } from './ProductsListItemLightboxTitle';
